import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface InsuranceFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
}

export function InsuranceFields({
  profile,
  setProfile,
  readOnly
}: InsuranceFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">Krankenversicherung</label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Bist du in Deutschland krankenversichert?</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly}
          value={profile?.health_insurance}
          onValueChange={(value) =>
            setProfile({ ...profile!, health_insurance: value })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Bitte auswählen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="yes">Ja</SelectItem>
            <SelectItem value="no">Nein</SelectItem>
            <SelectItem value="unknown">Ich weiß es nicht</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">
            Reisekrankenversicherung
          </label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Hast du eine Reisekrankenversicherung?</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly}
          value={profile?.travel_health_insurance}
          onValueChange={(value) =>
            setProfile({
              ...profile!,
              travel_health_insurance: value
            })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Bitte auswählen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="yes">Ja</SelectItem>
            <SelectItem value="no">Nein</SelectItem>
            <SelectItem value="unknown">Ich weiß es nicht</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
